import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RecruiterServices } from '../shared/services/recruiter.services';
import { RecruiterList, Studies } from './model/recruiter.model';
import { StudiesService } from '../shared/services/studies.service';
import { CreateRecruiterComponent } from './create/create.component';
import { FocusMonitor } from '@angular/cdk/a11y';
import { MatSidenav } from '@angular/material/sidenav';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../services/login.service';
import { HomeService } from '../shared/services/home.service';
import { Result } from '../project/model/project/project.model';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-manage-requiters',
  templateUrl: './recruiter.main.component.html',
  styleUrls: ['./recruiter.main.component.scss']
})
export class RecruiterMainComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('sidenav2', {static: false}) sidenavRef: MatSidenav;
  datasource: any;
  displayedColumns;
  recruiter: RecruiterList[] = [];
  public allStudies: Studies;
  // public allrecruiters: RecruiterStudy;
  addRecruiter = false;
  editRecruiter = false;
  manageRecruiter = false;
  urlParams: any;
  studyParams: any;
  projectParams: any;
  checked: false;
  fillData: any;
  originalData: any;
  showRecruiter = false;
  recruiterData: {};
  showLoader: boolean;
  noData: any;
  errorText: any;
  selectedRecruiter: any = {};
  assignRecruiterView: any;
  id: any;
  allRecruiters: any;
  AllRecruiter: any;
  accessRoles: any;
  loc: any;
  public isViewer:boolean = false;

  // scroll pagination
  throttle = 150;
  scrollDistance = 2;
  pageData = { pageNo: 1, pageLimit: 50 };

  public recruitersToShow: any;

  public project_id: string = "";
  public detailsNameFull: string = "";

  // @ViewChild('sidenav2', {static: false}) sidenav2: MatSidenav;

  constructor(
    private recruiterService: RecruiterServices,
    private studiesService: StudiesService,
    private router: Router, private _focusMonitor: FocusMonitor,
    private logerror: LoginService,
    private activeRoute: ActivatedRoute,
    private notifier: NotifierService,
    private homeService: HomeService
  ) {
    this.showLoader = true;
    //this.homeService.sidenav2Open.next(true);

  }


  ngOnInit() {
    //   this.homeService.sidenav2Open.next(true);
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
    this.isViewer = (this.accessRoles.access_type && this.accessRoles.access_type == 'viewer') ? true : false;
    if (this.router.url.indexOf('projects') !== -1) {
      this.id = this.router.url.split('/')[4];
    }
    else {
      this.id = this.router.url.split('/')[3];
    }
    if (this.id) {
      this.urlParams = this.id;
      this.homeService.checkRepoDetailsEvent.emit(this.id);
    }
    else {
      this.urlParams = 'not present';
    }
    this.onFetchStudies();
    if (this.urlParams !== 'not present') {
      //   this.homeService.sidenav2Open.next(true);
      this.displayedColumns = ['sno', 'recruiter_id', 'recruiter_name', 'phone', 'responses', 'location', 'status', 'action'];
    }
    else {
      this.displayedColumns = ['sno', 'recruiter_id', 'recruiter_name', 'phone', 'location', 'status', 'action'];
    }

    this.AllRecruiter = this.recruiterService.RecruiterData;
    this.recruiterService.loadRecruiter();
    this.pageData['pageNo'] = 0;
    if (this.urlParams !== 'not present') {
      this.pageData['pageNo'] = 0;
      this.getStudiesSpecific();
      this.recruiterService.getAllRecruiter().subscribe(data => {
        data.result.filter(recruiter => { this.recruiter.push(recruiter); });
      });
    } else {
      this.homeService.isOpen = false;
      this.getRecruiter();
    }
    this.activeRoute.queryParams.subscribe(
      (query) => {
        if (query.gloableSearch === '1') {
          this.getRecruiterById(query.id);
          this.onFetchStudies();
          setTimeout(() => { this.sidenavRef.open(); });
        }
      }
    );
  }

  ngAfterViewInit() {
    this._focusMonitor.stopMonitoring(document.getElementById('closeBtn'));
  }
  onFetchStudies() {
    this.studiesService.fetchStudies()
      .subscribe(data => {
        if (data.responseCode === 1) {
          this.allStudies = data;
          // console.log("sudies data  ====>>>> "+JSON.stringify(this.allStudies));
        } else {
        }
      },
        error => { // error path
          if (error.status === 500) {
            this.errorText = 'Something went wrong';
            this.showLoader = false;
            this.noData = true;
          } else if (error.status === 401) {
            this.errorText = 'User is not authorised';
            this.showLoader = false;
            this.noData = true;
            this.router.navigate(['home/access-denied']);
          }
          else {
            this.router.navigate(['home/access-denied']);
          }
        });
  }
  onEdit(id) {
    this.editRecruiter = true;
    this.addRecruiter = false;
    this.assignRecruiterView = false;
    this.selectedRecruiter = this.findRecruiterById(id)[0];
  }
  onManage(id) {

  }
  onAdd() {
    this.addRecruiter = true;
  }
  onClose(sidenav2) {
    this.sidenavRef.toggle();
    this.addRecruiter = false;
    this.editRecruiter = false;
    this.manageRecruiter = false;
    this.showRecruiter = false;
    this.assignRecruiterView = false;
  }

  showRecruiterView(recruiter, sidenav2:any) {
    if(!this.isViewer){
      sidenav2.open();
      this.showRecruiter = true;
      this.assignRecruiterView = false;
      this.addRecruiter = false;
      this.recruiterData = recruiter;
    }
  }
  findRecruiterById(id) {
    return this.recruitersToShow.filter(recruiter => {
      if (recruiter.id === id) {
        recruiter.code = recruiter.recruiter_code;
        recruiter.name = recruiter.recruiter_name;
        return recruiter;
      }
    });
  }
  recruiterMenu(type) {
    if (type === 'all') {
      this.router.navigate(['/home/projects']);
    }
    else {
      this.router.navigate(['/home/projects', this.project_id]);
    }
  }

  statusHandle(recruiter, status) {
    status = status === true ? 1 : 0;
    if (this.urlParams !== 'not present') {
      this.recruiterService.addRemoveStudyRecruiter(this.urlParams, recruiter, status).subscribe(data => {
      },
        error => {
          if (error.status == 401) {
            this.notifier.notify('error', 'User is not authorised');
          }
        });
    }
    else {
      this.recruiterService.updateRecruiterStatus(recruiter, status).subscribe(data => { },
        error => {
          if (error.status == 401) {
            this.notifier.notify('error', 'User is not authorised');
          }
        });
    }
  }






  ngOnDestroy(): void {
    this.addRecruiter = false;
    this.editRecruiter = false;
    this.manageRecruiter = false;
    this.showRecruiter = false;

  }
  filterData(type) {
    if (type === 'active') {
      this.recruitersToShow = this.originalData;
      for (let i = 0; i < this.recruitersToShow.length; ++i) {
        this.recruitersToShow = this.recruitersToShow.filter(item => item.status === 1);
      }
    }
    else if (type === 'inactive') {
      this.recruitersToShow = this.originalData;
      for (let i = 0; i < this.recruitersToShow.length; ++i) {
        this.recruitersToShow = this.recruitersToShow.filter(item => item.status === 0);
      }
    }
    else {
      this.recruitersToShow = this.originalData;
    }
    if (this.recruitersToShow.length === 0) {
      this.errorText = 'There are no recruiters to show';
      this.noData = true;
      this.showLoader = false;
    }
    else {
      this.noData = false;
    }
  }
  filterLoc(type) {
    this.recruitersToShow = this.originalData;
    for (let i = 0; i < this.recruitersToShow.length; ++i) {
      this.recruitersToShow = this.recruitersToShow.filter(item => item.location !== null &&
        item.location.toLowerCase().indexOf(type.toLowerCase()) !== -1);
    }
    if (this.recruitersToShow.length === 0) {
      this.errorText = 'There are no recruiters to show';
      this.noData = true;
      this.showLoader = false;
    }
    else {
      this.noData = false;
    }
  }
  onRecruiterAssign() {
    this.assignRecruiterView = true;
    this.addRecruiter = false;
    const studyId = '9da0013b-92a0-4747-936d-bd44e829a9ab';
  }
  onScrollRecruiters() {
    if (this.urlParams !== 'not present') {
      this.getStudiesSpecific();
    } else {
      this.getRecruiter();
    }
  }

  getRecruiterById(id: any) {
    this.recruiterService.getRecruiterById(id).subscribe((data) => {
      this.recruiterData = data['result'][0];
      this.showRecruiter = true;
      this.assignRecruiterView = false;
      this.addRecruiter = false;
    });
  }

  getRecruiter() {
    this.pageData['pageNo']++;
    this.recruiterService.getPaginationRecruiter(this.pageData).subscribe(data => {
      if (data.result && data.result.length !== 0) {
        if (this.urlParams === 'not present') {
          this.datasource = data.result;
          if (this.pageData['pageNo'] === 1) {
            this.recruitersToShow = this.datasource;
            this.originalData = data.result;
          } else {
            this.recruitersToShow = [...this.recruitersToShow, ...this.datasource];
          }
        }
        this.noData = false;
        this.showLoader = false;
      }
      else {
        if (this.pageData['pageNo'] === 1) {
          this.errorText = 'There are no recruiters to show';
          this.noData = true;
          this.showLoader = false;
        }
      }
    },
      error => { // error path
        if (error.status === 403 || error.status == 401) {
          this.router.navigate(['home/access-denied']);
        }
        else {
          this.errorText = 'Something went wrong';
          this.showLoader = false;
          this.noData = true;
        }
      }
    );
  }

  getStudiesSpecific() {
    this.pageData['pageNo']++;
    this.recruiterService.getSpecificRecruiter(this.urlParams, this.pageData).subscribe(data => {
      this.assignRecruiterView = true;
      this.studyParams = data.study_name.length > 80 ? data.study_name.slice(0, 80) + "..." : data.study_name;
      this.projectParams = data.project_name; //.length > 10 ? data.project_name.slice(0,10)+'...': data.project_name ;
      this.project_id = data.project_id;

      this.detailsNameFull = data.study_name;



      if (data.result.length !== 0) {
        this.datasource = data.result;
        if (this.pageData['pageNo'] === 1) {
          this.recruitersToShow = this.datasource;
          this.originalData = data.result;
        } else {
          this.recruitersToShow = [...this.recruitersToShow, ...this.datasource];
          this.originalData = [...this.originalData, ...data.result];
        }
        this.noData = false;
        this.showLoader = false;
      }
      else {
        if (this.pageData['pageNo'] === 1) {
          this.errorText = 'There are no recruiters to show';
          this.noData = true;
          this.showLoader = false;
        }
      }
      if (this.urlParams !== 'not present') {
      }
    },
      error => {
        if (error.status === 500) {
          this.errorText = 'Something went wrong';
          this.showLoader = false;
          this.noData = true;
        } else if (error.status === 401) {
          this.errorText = 'Something went wrong';
          this.showLoader = false;
          this.noData = true;
          this.router.navigate(['home/access-denied']);
        }
        else {
          this.router.navigate(['home/access-denied']);
        }
      });
  }
}





